import React, {forwardRef} from "react"
import SearchIcon from "@mui/icons-material/Search";
import {noop} from "@/lib/misc/noop";
import {useCLSX} from "@/hooks/use-clsx";

type Props = {
    initialValue?: string
    onChange?: (value: string) => void
    disabled?: boolean
}


export const SearchInput = forwardRef<HTMLInputElement, Props>(
    ({
         initialValue = "",
         onChange = noop,
         disabled = false
     }, ref) => {
        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value.replace(/[^a-zA-Z0-9\-_.@]/g, " "));
        }

        const style = useCLSX(
            "bg-white py-4 px-8 rounded-md outline outline-2 outline-light-light-grey w-full",
            {
                "opacity-50": disabled,
            }
        )

        return (

            <div className="relative w-full">
                <div className="h-full absolute right-4 flex items-center">
                    <SearchIcon className="text-light-grey"/>
                </div>
                <input className={style}
                       ref={ref}
                       type="search"
                       placeholder="Search..."
                       onChange={handleChange}
                       defaultValue={initialValue}
                       disabled={disabled}
                />
            </div>
        )
    }
)

SearchInput.displayName = "SearchInput";